module.exports = __webpack_public_path__ + "img/login-vector.11f54741.svg";